import { z } from 'zod';

// 企業編集フォーム（CompaniesProfileCard）用のバリデーション。
// フォーム値はすべて文字列で保持しているため、各フィールドは z.string() ベースで定義する。
// 会社名(name)は RHF 管理外（ローカル state）のためここには含めず、コンポーネント側で必須チェックする。
export const companiesEditSchema = z.object({
  customData: z.record(z.string(), z.string()),
  industry_id: z.string(),
  description: z.string(),
  official_url: z
    .string()
    .url('＊URLの形式が正しくありません。「https://」から始まるURLを入力してください。')
    // z.url() は http:// や ftp:// も許可するため、エラーメッセージ通り https:// 始まりに限定する
    .startsWith(
      'https://',
      '＊URLの形式が正しくありません。「https://」から始まるURLを入力してください。'
    )
    .or(z.literal('')),
  address: z.string().min(1, '＊住所は必須項目です。入力してください。'),
  number_of_employees: z.string(),
  established_date: z.string(),
  president_name: z.string(),
  listed_phase: z.string(),
  contract_status: z.string(),
  fee_rate: z.string(),
  minimum_fee: z.string(),
  note: z.string(),
});

export type CompaniesEditInput = z.infer<typeof companiesEditSchema>;
